import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Section, Eyebrow } from "./Primitives";
import { MaskedLines } from "./Reveal";
import { WHO } from "../../data/content";

export function WhoItsFor() {
  const [active, setActive] = useState(null);

  return (
    <Section id="who" className="py-24 md:py-36">
      <Eyebrow>{WHO.eyebrow}</Eyebrow>
      <h2 className="mt-8 max-w-5xl font-display text-4xl font-light leading-[1.06] tracking-[-0.015em] text-content sm:text-5xl md:text-6xl">
        <MaskedLines lines={[WHO.titleParts]} />
      </h2>

      <div className="mt-14 md:mt-20" onMouseLeave={() => setActive(null)}>
        {WHO.industries.map((ind, i) => {
          const on = active === i;
          return (
            <motion.div
              key={ind.name}
              onMouseEnter={() => setActive(i)}
              data-testid={`industry-row-${i}`}
              className="group relative cursor-pointer border-t border-line last:border-b"
              initial={false}
              animate={{ backgroundColor: on ? "var(--surface)" : "rgba(0,0,0,0)" }}
              transition={{ duration: 0.4 }}
            >
              <div className="flex flex-col gap-3 px-4 py-7 md:flex-row md:items-center md:gap-8 md:px-8 md:py-9">
                <span className="font-display text-sm font-bold text-accent-c md:w-12">{ind.n}</span>
                <motion.h3
                  animate={{ x: on ? 8 : 0, opacity: on ? 1 : 0.55 }}
                  transition={{ duration: 0.4 }}
                  className="flex-1 font-display text-3xl font-light tracking-tight text-content sm:text-4xl md:text-5xl"
                >
                  {ind.name}
                </motion.h3>
                <div className="flex items-center gap-6 md:w-[38%]">
                  <AnimatePresence mode="wait">
                    {on && (
                      <motion.p
                        key={ind.name}
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.35 }}
                        className="text-base leading-relaxed text-mutedc"
                      >
                        {ind.line}
                      </motion.p>
                    )}
                  </AnimatePresence>
                  <motion.span
                    animate={{ opacity: on ? 1 : 0, rotate: on ? 0 : -45 }}
                    className="hidden shrink-0 text-content md:block"
                  >
                    <ArrowUpRight size={26} />
                  </motion.span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
